import WebViewer from '@pdftron/pdfjs-express-viewer';
import { useEffect, useRef } from 'react';

export const PdfjsExpressViewer = ({ src }: { src: string }) => {
  const viewer = useRef(null);

  useEffect(() => {
    WebViewer(
      {
        path: '/webviewer/lib',
        initialDoc: src,
        licenseKey: import.meta.env.VITE_PDF_EXPRESS_LICENSE_KEY,
      },
      viewer.current
    ).then((instance) => {
      // now you can access APIs through the WebViewer instance
      const { Core } = instance;

      // adding an event listener for when a document is loaded
      Core.documentViewer.addEventListener('documentLoaded', () => {
        console.log('document loaded');
      });
    });
  }, [src]);

  return <div className='webviewer' ref={viewer} style={{ height: '80dvh' }}></div>;
};
